export default function id (context, args, flags) {
  return context.id.toString()
}



// WEBPACK FOOTER //
// ./src/natos/commands/id.js